import { PkgShippingMethod, PkgStatus, PkgWarehouse, UserPkg } from '@/api/user-package/types/UserPkg'

const DEMO_BASE: Omit<UserPkg, 'id' | 'brand' | 'fromTrackingNumber' | 'toTrackingNumber'> = {
  arrivalDate: '2025-03-15',
  dimensions: { weight: 1.36, height: 10, length: 20, width: 15 },
  shippingAddress: {
    address: 'Demo St 1',
    apartmentNumber: '1',
    city: 'Tel Aviv',
    postalCode: '6100000',
  },
  isFlammable: false,
  isShrinked: false,
  createdAt: '2025-03-15T10:00:00.000Z',
  isShipped: false,
  isPaid: false,
  contents: [{ productCategory: 'Clothes', quantity: 5 }],
  readyAt: '2025-03-15T12:00:00.000Z',
  status: PkgStatus.Ready,
  warehouse: PkgWarehouse.USA,
  shippingMethod: PkgShippingMethod.DoorToDoor,
  valueInUSD: 80,
  buyingReciptKey: '',
  price: 0,
  falseReceiptDate: '',
  canCancelReturnRequest: false,
  canCancelShipment: false,
}

/** Demo packages shown during onboarding when the user has no real packages. */
export const ONBOARDING_DEMO_PKGS: UserPkg[] = [
  {
    ...DEMO_BASE,
    id: 'onboarding-demo-pkg-1',
    brand: 'SEPHORA',
    fromTrackingNumber: 'DEMO-SEPHORA-001',
    toTrackingNumber: '',
  },
  {
    ...DEMO_BASE,
    id: 'onboarding-demo-pkg-2',
    brand: 'ZARA',
    fromTrackingNumber: 'DEMO-ZARA-001',
    toTrackingNumber: '',
    dimensions: { weight: 1.36, height: 12, length: 22, width: 16 },
  },
  {
    ...DEMO_BASE,
    id: 'onboarding-demo-pkg-3',
    brand: 'ZARA',
    fromTrackingNumber: 'DEMO-ZARA-002',
    toTrackingNumber: '',
    dimensions: { weight: 0.9, height: 8, length: 18, width: 12 },
    contents: [{ productCategory: 'Clothes', quantity: 3 }],
  },
]
